<div class="container-modal">
 <section class="p-24">
  <div class="modal-title d-flex justify-content-between">
    <p class="p-0 m-0 fts-20 font-bold-dali title-product">
      Ingresa los códigos de tus producto
    </p>
    <div class="button-x justify-content-end d-flex">
      <img
        class="cursor-pointer"
        src="assets/image/modal/close-modal.svg"
        alt="close"
        width="14px"
        (click)="exit()"
      />
    </div>
  </div>
  <hr class="dividing-line-solid my-3" />
  <div class="modal-body">
    <div class="table-content">
      <div class="table-header">
        <div class="th th1">
          <p class="fts-14 font-bold-dali m-0 p-0">
            Fila
          </p>
        </div>
        <div class="th th2">
          <p class="fts-14 font-bold-dali m-0 p-0">
            SKU
          </p>
        </div>
        <div class="th th3">
          <p class="fts-14 font-bold-dali m-0 p-0">
            Cantidad
          </p>
        </div>
      </div>
      <div class="table-body" [formGroup]="dataForm">
        <ng-container formArrayName="products">
          <ng-container  *ngFor="let productForm of products.controls; let i = index">
              <div class="tb-row"[formGroup]="productForm">
                <div class="tb tb1">
                  <p class="fts-14 font-bold-dali p-0 m-0 ta-c" >
                    {{i + 1}}
                  </p>
                </div>
                <div class="tb tb2">
                  <label [attr.for]="'excel-sku-' + i" class="sr-only">SKU</label>
                  <input [id]="'excel-sku-' + i" matInput
                  formControlName="sku">
                </div>
                <div class="tb tb3">
                  <label [attr.for]="'excel-quantity-' + i" class="sr-only">Cantidad</label>
                  <input [id]="'excel-quantity-' + i" matInput #referenceInput (blur)="deactiveFlag()" (click)="activeFlag()"
                  formControlName="quantity">
                </div>
              </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
 </section>
 <hr class="dividing-line-solid" />
  <div class="buttons">
    <button class="btn-cancel d-flex justify-content-center align-items-center" (click)="exit()">
      Cancelar
    </button>
    <button  class="btn-green d-flex justify-content-center align-items-center"(click)="sendData()" >
      Aceptar y continuar
    </button>
   
  </div>
</div>
